/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowrefinedarker3Inputs */

const en_aiflowrefinedarker3 = /** @type {(inputs: Aiflowrefinedarker3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darker`)
};

const de_aiflowrefinedarker3 = /** @type {(inputs: Aiflowrefinedarker3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dunkler`)
};

/**
* | output |
* | --- |
* | "Darker" |
*
* @param {Aiflowrefinedarker3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowrefinedarker3 = /** @type {((inputs?: Aiflowrefinedarker3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowrefinedarker3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowrefinedarker3(inputs)
	return de_aiflowrefinedarker3(inputs)
});
export { aiflowrefinedarker3 as "aiFlowRefineDarker" }